import { useState, useEffect } from 'react';

// Define o ponto de quebra para considerar um dispositivo como "mobile"
const MOBILE_BREAKPOINT: number = 768;

/**
 * Hook personalizado para detetar se o utilizador está num dispositivo móvel (por largura do ecrã).
 * @returns {boolean} Retorna 'true' se a largura da janela for menor ou igual ao ponto de quebra, 'false' caso contrário.
 */
const VerificaSeUsuarioEstaNoMobile = (): boolean => {
  // 1. Estado: Tipado explicitamente como boolean.
  const [isMobile, setIsMobile] = useState<boolean>(
    typeof window !== 'undefined' ? window.innerWidth <= MOBILE_BREAKPOINT : false
  );
  
  // Raciocínio para o typeof window !== 'undefined':
  // Isto é uma boa prática em React/Next.js. Garante que o código não falha
  // durante a Server-Side Rendering (SSR), onde 'window' não existe.
  // No caso de SSR, o valor inicial será 'false', e o 'useEffect' irá corrigir o valor no cliente.

  // 2. Efeito para adicionar e remover o "listener" de redimensionamento.
  useEffect(() => {
    // Se 'window' não estiver definido (SSR), saímos do useEffect.
    if (typeof window === 'undefined') {
        return; 
    }
      
    /**
     * Função que verifica a largura da janela e atualiza o estado.
     */
    const handleResize = (): void => {
      // Cálculo booleano da condição mobile
      const newIsMobile: boolean = window.innerWidth <= MOBILE_BREAKPOINT;
      
      // Atualiza o estado apenas se houver uma mudança real
      if (newIsMobile !== isMobile) {
        setIsMobile(newIsMobile);
      }
    };

    // Adiciona o "listener" de redimensionamento.
    window.addEventListener('resize', handleResize);

    // 3. Função de limpeza.
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isMobile]); // O array de dependências continua importante

  return isMobile;
};

export default VerificaSeUsuarioEstaNoMobile;